import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaPlus, FaFolder, FaImage } from 'react-icons/fa';
import api from '../api/axios';
import './Dashboard.css';

// 🔥 Correction Mixed Content : toujours utiliser le domaine courant en HTTPS
const API_BASE_URL = window.location.origin;

const Dashboard = () => {
  const [albums, setAlbums] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newAlbum, setNewAlbum] = useState({ name: '', description: '' });
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    loadAlbums();
  }, []);

  const loadAlbums = async () => {
    try {
      const response = await api.get('/albums');
      console.log('📦 Albums reçus:', response.data);

      response.data.forEach(album => {
        console.log(`Album "${album.name}":`, {
          media_count: album.media_count,
          preview_image: album.preview_image,
          preview_thumbnail: album.preview_thumbnail,
          cover_image: album.cover_image
        });
      });

      setAlbums(response.data);
    } catch (error) {
      console.error('Erreur lors du chargement des albums', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateAlbum = async (e) => {
    e.preventDefault();
    try {
      await api.post('/albums', newAlbum);
      setShowModal(false);
      setNewAlbum({ name: '', description: '' });
      loadAlbums();
    } catch (error) {
      alert('Erreur lors de la création de l\'album');
    }
  };

  const handleDeleteAlbum = async (albumId) => {
    if (window.confirm('Voulez-vous vraiment supprimer cet album ?')) {
      try {
        await api.delete(`/albums/${albumId}`);
        loadAlbums();
      } catch (error) {
        alert('Erreur lors de la suppression');
      }
    }
  };

  if (loading) {
    return <div className="loading">Chargement...</div>;
  }

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Mes Albums</h1>
        <button className="btn-create" onClick={() => setShowModal(true)}>
          <FaPlus /> Nouvel Album
        </button>
      </div>

      <div className="albums-grid">
        {albums.map(album => (
          <div 
            key={album.id} 
            className="album-card"
            onClick={() => navigate(`/album/${album.id}`)}
          >
            <div className="album-cover">
              {album.preview_thumbnail || album.preview_image ? (
                <>
                  <img 
                    src={`${API_BASE_URL}/${album.preview_thumbnail || album.preview_image}`} 
                    alt={album.name}
                    className="album-preview-img"
                  />
                  {album.media_count > 0 && (
                    <div className="media-count-badge">
                      <FaImage /> {album.media_count}
                    </div>
                  )}
                </>
              ) : album.cover_image ? (
                <img src={`${API_BASE_URL}/${album.cover_image}`} alt={album.name} />
              ) : (
                <div className="album-placeholder">
                  <FaFolder className="folder-icon" />
                  <p className="no-media-text">Aucune photo</p>
                </div>
              )}
            </div>

            <div className="album-info">
              <h3>{album.name}</h3>
              <p className="album-description">{album.description}</p>
              <div className="album-stats">
                <span><FaImage /> {album.media_count} médias</span>
                {album.sub_albums_count > 0 && (
                  <span className="sub-albums-indicator">
                    📁 {album.sub_albums_count} sous-album{album.sub_albums_count > 1 ? 's' : ''}
                  </span>
                )}
              </div>
            </div>

            <button 
              className="btn-delete-album"
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteAlbum(album.id);
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>

      {albums.length === 0 && (
        <div className="empty-state">
          <FaFolder size={64} color="#ccc" />
          <p>Aucun album pour le moment</p>
          <button className="btn-create" onClick={() => setShowModal(true)}>
            Créer votre premier album
          </button>
        </div>
      )}

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Nouvel Album</h2>
            <form onSubmit={handleCreateAlbum}>
              <div className="form-group">
                <label>Nom de l'album</label>
                <input
                  type="text"
                  value={newAlbum.name}
                  onChange={(e) => setNewAlbum({...newAlbum, name: e.target.value})}
                  required
                  placeholder="Vacances 2024"
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  value={newAlbum.description}
                  onChange={(e) => setNewAlbum({...newAlbum, description: e.target.value})}
                  placeholder="Description de l'album..."
                  rows="3"
                />
              </div>

              <div className="modal-actions">
                <button type="button" onClick={() => setShowModal(false)} className="btn-cancel">
                  Annuler
                </button>
                <button type="submit" className="btn-primary">
                  Créer
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
